import { AttributeType } from '../../data/types/attributes';
import { CURRENT_CURRENCY } from '../../config/constants';
import { StoreDetails } from '../../data/types/stores';
import DOMPurify from 'dompurify';
import { EN_AR_TRANSLATION_SPLIT_CHAR } from '../../pages/create_listings/constants';

export function formatStoreBankDetails(store: StoreDetails) {
  return formatBankDetails(
    store.bank_account_number,
    store.bank_branch_number,
    store.bank_number,
  );
}

export function formatBankDetails(
  bank_account_number: number,
  bank_branch_number: number,
  bank_number: number,
) {
  return `${bank_account_number} · ${bank_branch_number} · ${bank_number}`;
}

export function formatDecimals(value?: string | number) {
  if ((value !== 0 && !value) || value === undefined) return 'N/A';
  if (typeof value === 'string' && value?.includes('.')) {
    const [integer, decimals] = value.split('.');
    return `${integer}.${decimals.substring(0, 2)}`;
  }
  if (typeof value === 'number')
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  return value + '.00';
}

export function formatPercentage(value?: string) {
  if (!value) return 'N/A%';
  if (parseFloat(value) > 1) {
    if (value.includes('.')) {
      const [integer, decimals] = value.split('.');
      return `${integer}.${decimals.substring(0, 2)}%`;
    }
    return value + '.00%';
  }
  return parseFloat(value) * 100 + '%';
}

export function formatPrice(value?: string | number) {
  if (!value) return CURRENT_CURRENCY + 'N/A';
  return CURRENT_CURRENCY + formatDecimals(value);
}

export function formatAttributeName(
  en_val: string | undefined,
  ar_val: string | undefined,
) {
  if (!en_val && !ar_val) return 'N/A';
  if (!en_val) return ar_val;
  if (!ar_val) return en_val;
  return `${en_val} - ${ar_val}`;
}

export function formatAttributeValues(
  en_val: string | undefined,
  ar_val: string | undefined,
  type: number,
) {
  const hasArabic =
    ar_val !== 'null' && ar_val !== undefined && ar_val?.length > 0;
  const hasEnglish =
    en_val !== 'null' && en_val !== undefined && en_val?.length > 0;

  if (type === AttributeType.NUMERIC) return formatDecimals(en_val || ar_val);
  if (type === AttributeType.BOOLEAN) return en_val;
  if (!hasEnglish && !hasArabic) return 'N/A';
  if (!hasEnglish) return ar_val;
  if (!hasArabic) return en_val;
  return `${en_val} ${EN_AR_TRANSLATION_SPLIT_CHAR} ${ar_val}`;
}

export const sanitizeHTML = (html: string) => {
  return {
    __html: DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        'b',
        'i',
        'strong',
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'ul',
        'ol',
        'li',
        'br',
        'span',
        'div',
        'img',
      ],
      FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'video'],
      FORBID_ATTR: ['onerror', 'onload', 'onmouseover', 'onclick'],
    }),
  };
};
